import { Typography } from '@mui/material';
import { Fragment } from 'react';
import { PecForm } from '.';

interface FormPecDetailProps {
  values?: PecForm;
}

const FormPecDetail = ({ values }: FormPecDetailProps): React.ReactElement => {
  return (
    <Fragment>
      <Typography variant="body1">
        <strong>Da:</strong> {values?.sender}
      </Typography>
      <Typography variant="body1">
        <strong>A:</strong> {values?.receiver}
      </Typography>
      {values?.descRecipient ? (
        <Typography variant="body1">
          <strong>Destinatario:</strong> {values?.descRecipient}
        </Typography>
      ) : undefined}
      {values?.cc ? (
        <Typography variant="body1">
          <strong>CC:</strong> {values?.cc}
        </Typography>
      ) : undefined}
      <Typography variant="body1">
        <strong>Oggetto:</strong> {values?.subject}
      </Typography>
      <Typography variant="body1">
        <strong>Allegati:</strong>
        {values?.attachments?.map((currentFile) => (
          <span key={`key-${currentFile?.name}`}>
            <a
              download={currentFile?.name}
              href={currentFile.raw ? `data:application/pdf;base64, ${currentFile.raw}` : ''}
            >
              {currentFile?.name}
            </a>
          </span>
        ))}
      </Typography>
    </Fragment>
  );
};

FormPecDetail.displayName = 'Form Pec Detail component';

export default FormPecDetail;
